import { render, staticRenderFns } from "./lottery-coupon.vue?vue&type=template&id=42ba61c2&scoped=true&"
import script from "./lottery-coupon.vue?vue&type=script&lang=js&"
export * from "./lottery-coupon.vue?vue&type=script&lang=js&"
import style0 from "./lottery-coupon.vue?vue&type=style&index=0&id=42ba61c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba61c2",
  null
  
)

export default component.exports